import { render } from "./MaterialIcons.vue?vue&type=template&id=1f5fce98"
import script from "./MaterialIcons.vue?vue&type=script&lang=js"
export * from "./MaterialIcons.vue?vue&type=script&lang=js"
script.render = render

export default script